import { render, staticRenderFns } from "./item-balances.vue?vue&type=template&id=f7eca9ac&scoped=true"
import script from "./item-balances.vue?vue&type=script&lang=js"
export * from "./item-balances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7eca9ac",
  null
  
)

export default component.exports